import axios from 'axios'
import {
  // Loading,
  Message
} from 'element-ui'
import router from '@/router/index'
import store from '@/store/';
import commonMethods from '@/mixins/commonMethods'
import {
  systemLinkApi
} from '@/settings'

const request = axios.create({
  baseURL: systemLinkApi, // 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
  timeout: 30000,
  withCredentials: true
})

let aaa = {}
// var loadingInstance
// var isLoad = false

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
  console.log(config, 'config')
  aaa = config
  if (config.url === '/upload/save') {
    config.headers['Content-Type'] = 'multipart/form-data'
  } else {
    config.headers['Content-Type'] = 'application/json;charset=utf-8'
  }
  // 获取保持登录有效期
  // 20240229注释
  // commonMethods.methods.getLocalExpire('logonExpire')
  // 如果type == 1 不显示加载中
  // if (config.type != 1) {
  //   isLoad = true
  // } else {
  //   isLoad = false
  // }
  // if (isLoad) {
  //   let options = {
  //     text: '加载中'
  //   }
  //   loadingInstance = Loading.service(options)
  // }

  // console.log(sessionStorage.getItem('token'), 'token')
  config.headers['token'] = localStorage.getItem('token')

  const storeUserInfo = store.state.user.userInfo
  // 20251127 新增顶号后 加载最新的用户
  if (localStorage.getItem('userInfo') && JSON.stringify(storeUserInfo) !== '{}') {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    console.log(userInfo.content, storeUserInfo.id, 'userInfo, storeUserInfo')
    if (userInfo.content.id !== storeUserInfo.id) {
      store.state.user.userInfo = userInfo.content
    }
  }

  // 20240229 注释 || sessionStorage.getItem('token') || ''; // 设置请求头
  return config
}, error => {
  return Promise.reject(error)
})

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
  response => {
    let res = response.data
    // 如果是返回的文件
    if (response.config.responseType === 'blob') {
      return res
    }
    // 兼容服务端返回的字符串数据
    if (typeof res === 'string') {
      res = res ? JSON.parse(res) : res
    }

    // 20240229 注释
    // let logonExpire = localStorage.getItem('logonExpire')

    if (response.headers['token']) {
      let token = response.headers['token'] || ''
      localStorage.setItem('token', token)
      // 20240229 注释
      // console.log(logonExpire, logonExpire > 0, 'ddd')
      // 有值  当前为保持登录
      // if (logonExpire > 0) {
      //   // 保持登录时一直缓存token 直至过期 （本系统的token）
      //   sessionStorage.removeItem('token')
      //   localStorage.setItem('token', token)

      //   // if (logonExpire > 0) {
      //   //   // 设置保持登录有效期
      //   //   commonMethods.methods.setLocalExpire('logonExpire', logonExpire)
      //   // }
      // } else {
      //   // 无保持登录时 浏览器关闭后删除token （本系统的token）
      //   sessionStorage.setItem('token', token)
      //   localStorage.removeItem('token')
      // }
    }

    // if (loadingInstance) {
    //   loadingInstance.close()
    // }
    console.log(11112)
    // if (status === 401) store.dispatch('FedLogOut').then(() => router.push({path: '/login'}));
    if (res.code === 401) {
      Message.warning('请登录')
      setTimeout(() => {
        // 20241216 新增注释
        // // 进入去登录页
        // commonMethods.methods.goLogin()
        // // 重置登录状态
        // commonMethods.methods.resetLogin()
        // 20241216 新增
        // 重置登录状态并进入去登录页
        commonMethods.methods.reset('401')
      }, 500)
    }
    return res
  },
  error => {
    // loadingInstance.close()
    if (aaa.url !== '/message/getUnReadMessage' && aaa.url !== '/order/get' && aaa.url !== '/order/pay') {
      Message.error('网络错误，请重新加载' + aaa.url)
    }
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default request



// WEBPACK FOOTER //
// ./src/api/axios.js